<template>
  <div class="repair-items app-region blank-t-v blank-l-h blank-r-h">
    <a-card :bordered="false">
      <div class="table-page-search-wrapper">
        <H2 style="margin-bottom: 40px">商品管理</H2>
        <a-form>
          <a-row>
            <a-col :md="8" :sm="24">
              <a-form-item label="商品名称" style="margin-bottom: 0px">
              </a-form-item>
            </a-col>
            <a-col :md="8" :sm="24">
              <a-form-item label="商品分类" style="margin-bottom: 0px">
              </a-form-item>
            </a-col>
          </a-row>
          <a-row :gutter="48">
            <a-col :md="8" :sm="24">
              <a-form-item label="">
                <a-input
                  v-model="table.search.goodsName"
                  placeholder="请输入商品名称"
                />
              </a-form-item>
            </a-col>
            <a-col :md="8" :sm="24" style="padding-left: 9px">
              <a-form-item label="">
                <a-select
                  placeholder="请选择商品分类"
                  v-model="table.search.category"
                >
                  <a-select-option
                    :value="value.id"
                    v-for="value in table.initData.categoryOptions"
                    :key="value.id"
                    >{{ value.name }}</a-select-option
                  >
                </a-select>
              </a-form-item>
            </a-col>
            <a-col :md="8 || 24" :sm="24">
              <span
                class="table-page-search-submitButtons"
                :style="{ float: 'center', overflow: 'hidden' } || {}"
              >
                <a-button
                  type="primary"
                  @click="toSearch"
                  style="font-style: italic"
                  >查询</a-button
                >
                <a-button
                  style="margin-left: 8px; font-style: italic"
                  @click="resetSearch"
                  >重置</a-button
                >
              </span>
            </a-col>
          </a-row>
        </a-form>
      </div>
      <div class="table-operator" style="margin: 20px 0">
        <a-button type="primary" icon="plus" @click="toCreate"
          >新建商品</a-button
        >
        
      </div>
      <!-- 表格 -->
      <a-spin tip="加载中..." :spinning="table.loading">
      <a-table
        :columns="columns"
        :data-source="table.data"
        rowKey="id"
        :pagination="table.page"
        @change="handlePageChange"
      >
        <span slot="image" slot-scope="image">
          <img :src="image" width="40" height="40" style="border-radius: 5px" />
        </span>
        <span slot="status" slot-scope="data">
          <div>
            <a-switch
              :checked="data.status == 'up'"
              @change="changeGoodsStatus(data)"
            />
          </div>
        </span>
        <span slot="action" slot-scope="text, data">
          <template>
            <a @click="handleEdit(data)">编辑</a>
            <a-divider type="vertical" />
            <a @click="handleDelete(data)">删除</a>
          </template>
        </span>
      </a-table>
      </a-spin>
    </a-card>
  </div>
</template>

<script>

import GoodsListService from "@/io/goods_list.js";
import GoodsTypeService from "@/io/goods_type.js";

// 表头
export default {
  name: "GoodsListPage",
  data() {
    let self = this;
    return {
      columns: [
        {
          title: "ID",
          dataIndex: "id",
          key: "id",
        },
        {
          title: "商品",
          dataIndex: "title",
          key: "title",
        },
        {
          title: "展示图",
          dataIndex: "image",
          key: "image",
          scopedSlots: { customRender: "image" },
        },
        {
          title: "价格",
          dataIndex: "price",
          key: "price",
        },
        {
          title: "销量",
          key: "sales",
          dataIndex: "sales",
        },
        {
          title: "展示销量",
          key: "show_sales",
          dataIndex: "show_sales",
          //   scopedSlots: { customRender: "status" },
        },
        {
          title: "库存",
          key: "stock",
          dataIndex: "stock",
          //   scopedSlots: { customRender: "status" },
        },
        {
          title: "状态",
          key: "status",
        //   dataIndex: "status",
          scopedSlots: { customRender: "status" },
        },
        {
          title: "更新时间",
          key: "updatetime",
          dataIndex: "updatetime",
          //   scopedSlots: { customRender: "status" },
        },
        {
          title: "操作",
          key: "action",
          scopedSlots: { customRender: "action" },
        },
      ],
      table: {
        loading:false,
        data: [],
        search: {
          goodsName: null,
          category: [],
        },
        initData: {
          categoryOptions: [],
        },
        page: {
          total: 10,
          current: 1,
          pageSize: 10,
          showQuickJumper: true,
          showSizeChanger: true,
          showTotal() {
            return `共${self.table.page.total}条`;
          },
        },
      },
    };
  },
  activated() {
    this.initGoodsList();
  },
  mounted() {
    this.initCategoryData();
  },
  computed: {
    rowSelection() {
      return {
        selectedRowKeys: this.selectedRowKeys,
        onChange: this.onSelectChange,
      };
    },
  },
  methods: {
    //   商品列表数据
    async initGoodsList() {
        this.table.loading = true
      const { page, search } = this.table;
      const res = await GoodsListService.list({
        title:search.goodsName,
        category_id:search.category,
        page:page.current,
        limit:page.pageSize
      });
      this.table.data = res.data.rows;
      this.table.page.total = res.data.total;
      this.table.loading = false
    },
    // 初始化商品分类
    async initCategoryData() {
      const res = await GoodsTypeService.list();
      this.table.initData.categoryOptions = res.data.rows;
    },
    // 更改状态
    async changeGoodsStatus({id,status}) {
        let resStatus = status == 'up'? 'down': 'up'
      const res = await GoodsListService.status([id],resStatus)
      let index = this.table.data.findIndex((val)=>{
        return val.id == id
      })
      this.table.data[index].status = resStatus
    },
    goGoodsDetail(id) {
      this.$router.push(`/goods/${id}`);
    },
    // 创建工单
    toCreate() {
      this.$router.push("/platform/goodslist/new");
    },
    handleAdd() {
      this.mdl = null;
      this.visible = true;
    },
    // 编辑
    handleEdit(data) {
      this.$router.push(`/platform/goodslist/new/${data.id}`);
    },
    // 删除
    async handleDelete(data) {
      this.$confirm({
          title: '提示',
          content: '确认删除？',
          onOk:()=> {
            GoodsListService.delete([data.id]).then(res => {
              this.initGoodsList()
              this.$message.success(res.msg);
            });
            
          }
        });
      
    },
    handlePageChange(page) {
      this.table.page.current = page.current;
      this.table.page.pageSize = page.pageSize;
      this.initGoodsList();
    },
    // 搜索
    toSearch() {
      this.table.page.current = 1;
      this.initGoodsList();
    },
    // 重置
    resetSearch() {
      this.table.search.goodsName = null;
      this.table.search.category = [];
    },
  },
};
</script>

